import React from 'react';
import { StyledIcon } from './styled';

const ColorTypeIcon = ({ type }) => <StyledIcon type={type} />;

export default ColorTypeIcon;
